import { BareButton } from '@calendly/ui/components/bare-button';
import classNames from 'classnames';
import { forwardRef } from 'react';
const modalContainerCss = "m1d5bys9";
export const ModalContainer = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  return <Component ref={ref} {...restProps} className={classNames(modalContainerCss, props.className)} />;
});
const optionCss = "o1v8l9rr";
export const Option = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  return <Component ref={ref} {...restProps} className={classNames(optionCss, props.className)} />;
});
const accordionContainerCss = "a1st19ll";
export const AccordionContainer = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  return <Component ref={ref} {...restProps} className={classNames(accordionContainerCss, props.className)} />;
});
const accordionBodyCss = "a1idc0n1";
export const AccordionBody = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  return <Component ref={ref} {...restProps} className={classNames(accordionBodyCss, props.className)} />;
});
const accordionHeaderCss = "a1snjgjt";
export const AccordionHeader = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  return <Component ref={ref} {...restProps} className={classNames(accordionHeaderCss, props.className)} />;
});
const accordionHeaderButtonCss = "a19si1ro";
export const AccordionHeaderButton = forwardRef((props, ref) => <BareButton ref={ref} {...props} className={classNames(accordionHeaderButtonCss, props.className)} />);
const accordionHeaderContentWrapperCss = "aiql67z";
export const AccordionHeaderContentWrapper = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  return <Component ref={ref} {...restProps} className={classNames(accordionHeaderContentWrapperCss, props.className)} />;
});

require("./styles.wyw-in-js.css!=!../../../../../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./styles.js");